import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import useAmplifyAuth from '../hooks/useAmplifyAuth';

const AuthContext = createContext(null);

function AuthProvider({ children }) {
    const { authStatus, authUser, getAuthUser } = useAmplifyAuth();
    // CognitoUser objects cannot be serialized, so we don't persist challengeUser.
    // If the user refreshes during password change, they'll need to sign in again.
    const [challengeUser, setChallengeUser] = useState(null);

    // Clear challengeUser when user successfully authenticates
    useEffect(() => {
        if (authStatus === 'authenticated' && challengeUser) {
            setChallengeUser(null);
        }
    }, [authStatus, challengeUser]);

    const value = useMemo(
        () => ({
            authUser,
            authStatus,
            getAuthUser,
            challengeUser,
            setChallengeUser,
        }),
        [authUser, authStatus, getAuthUser, challengeUser],
    );
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

AuthProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

function useAuth() {
    return useContext(AuthContext);
}

export { AuthContext, AuthProvider, useAuth };
export default useAuth;
